import { render } from "./HoverablePopup.vue?vue&type=template&id=09d2aa80&scoped=true&lang=pug"
import script from "./HoverablePopup.vue?vue&type=script&lang=js"
export * from "./HoverablePopup.vue?vue&type=script&lang=js"

import "./HoverablePopup.vue?vue&type=style&index=0&id=09d2aa80&scoped=true&lang=sass"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09d2aa80"]])

export default __exports__
import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';
import QMenu from 'quasar/src/components/menu/QMenu.js';
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QPopupProxy,QMenu});
